var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.value)?_c('div',_vm._b({staticClass:"dataset-cell-tag-status tag",class:[_vm.data.staticClass, _vm.props.class],style:({
    backgroundColor: _vm.props.value.ColorBackground,
    color: _vm.props.value.ColorText
  })},'div',_vm.data.attrs,false),[_c('b-tooltip',{attrs:{"active":_vm.$options.title(_vm.props)[0] !== null,"label":_vm.$options.title(_vm.props)[0],"type":_vm.$options.title(_vm.props)[1]}},[_vm._v(" "+_vm._s(_vm.props.value.Name)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }